module.exports = __webpack_public_path__ + "static/media/maelstrom.ea35fb2e.jpeg";